import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { useTranslation } from "react-i18next";
import { StatisticsOverview } from "../../../components/dashboard/statistics/StatisticsOverview";
import { TagDefinitionsSection } from "../../../components/dashboard/statistics/TagDefinitionsSection";

export const StatisticsPage = () => {
  const { t } = useTranslation();

  return (
    <DashboardHeader
      subtitle=""
      actions={[]}
      title={t("Statistics")}
      meta={[]}
    >
      <div className="mx-auto mt-8 max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="space-y-8">
          <StatisticsOverview />
          <TagDefinitionsSection />
        </div>
      </div>
    </DashboardHeader>
  );
};
